import {
  QUICK_INFO_BUTTONS,
  QuickInfoGroupItem,
} from '@aibees/elephant/components/quick-info-group/components/quick-info-button';
import { PeopleTableInfo } from '../../types';
import * as SX from './sx';
import {
  aiAnalysisBadgeMap,
  contactDetailsBadgeMap,
  contactDetailsHideBadge,
  emailEnrichmentBadgeMap,
  emailEnrichmentHideBadge,
  phoneNumberEnrichmentBadgeMap,
  phoneNumberEnrichmentHideBadge,
} from './utils';

export const config: QuickInfoGroupItem<PeopleTableInfo>[] = [
  {
    id: QUICK_INFO_BUTTONS.CONTACT_ENRICHMENT,
    icon: 'badge-outline',
    badge: (x) => contactDetailsBadgeMap(x),
    disabled: (x) => !x.available?.length,
    tooltipText: 'Profile Details not available',
    hideBadge: (x) => contactDetailsHideBadge(x),
    iconSx: SX.icon,
  },
  {
    id: QUICK_INFO_BUTTONS.EMAIL_ENRICHMENT,
    icon: 'email-outline',
    badge: (x) => emailEnrichmentBadgeMap(x),
    iconSx: SX.icon,
    hideBadge: (x) => emailEnrichmentHideBadge(x),
  },
  {
    id: QUICK_INFO_BUTTONS.PHONENUMBER_ENRICHMENT,
    icon: 'phone',
    badge: (x) => phoneNumberEnrichmentBadgeMap(x),
    hideBadge: (x) => phoneNumberEnrichmentHideBadge(x),
  },
  {
    id: QUICK_INFO_BUTTONS.PERSONALITY_ANALYSIS,
    icon: 'person-search-outline',
    badge: (x) => aiAnalysisBadgeMap(x),
    disabled: (x) => !x.link?.linkedin,
    hideBadge: (x) => !x.link?.linkedin,
    tooltipText: "This profile isn't available on LinkedIn",
    iconSx: SX.icon,
  },
];
